import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React, { Fragment } from 'react';
import { camelize } from '../libraries/String';
var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

var wrappedPromise = function wrappedPromise() {
  var wrappedPromise = {},
      promise = new Promise(function (resolve, reject) {
    wrappedPromise.resolve = resolve;
    wrappedPromise.reject = reject;
  });
  wrappedPromise.then = promise.then.bind(promise);
  wrappedPromise.catch = promise.catch.bind(promise);
  wrappedPromise.promise = promise;
  return wrappedPromise;
};

export var Marker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Marker, _React$Component);

  function Marker() {
    _classCallCheck(this, Marker);

    return _possibleConstructorReturn(this, _getPrototypeOf(Marker).apply(this, arguments));
  }

  _createClass(Marker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.markerPromise = wrappedPromise();
      this.renderMarker();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
        if (this.marker) this.marker.setMap(null);
        this.renderMarker();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.marker) this.marker.setMap(null);
    }
  }, {
    key: "renderMarker",
    value: function renderMarker() {
      var _this = this;

      var _this$props = this.props,
          map = _this$props.map,
          google = _this$props.google,
          position = _this$props.position,
          mapCenter = _this$props.mapCenter,
          icon = _this$props.icon,
          label = _this$props.label,
          draggable = _this$props.draggable,
          title = _this$props.title,
          props = _objectWithoutProperties(_this$props, ["map", "google", "position", "mapCenter", "icon", "label", "draggable", "title"]);

      if (!google) return null;
      var pos = position || mapCenter;
      if (!(pos instanceof google.maps.LatLng)) pos = new google.maps.LatLng(pos.lat, pos.lng);

      var pref = _objectSpread({
        map: map,
        position: pos,
        icon: icon,
        label: label,
        title: title,
        draggable: draggable
      }, props);

      this.marker = new google.maps.Marker(pref);
      evtNames.forEach(function (e) {
        _this.marker.addListener(e, _this.handleEvent(e));
      });
      this.markerPromise.resolve(this.marker);
    }
  }, {
    key: "getMarker",
    value: function getMarker() {
      return this.markerPromise;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(evt) {
      var _this2 = this;

      return function (e) {
        var evtName = "on".concat(camelize(evt));
        if (_this2.props[evtName]) _this2.props[evtName](_this2.props, _this2.marker, e);
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Fragment, null, this.props.children && this.marker ? React.Children.only(React.cloneElement(this.props.children, {
        marker: this.marker,
        google: this.props.google,
        map: this.props.map
      })) : null);
    }
  }]);

  return Marker;
}(React.Component);
Marker.defaultProps = {
  name: 'Marker'
};
export default Marker;